module.exports = __webpack_public_path__ + "static/media/partner05.d39e28a3.svg";